export default __webpack_public_path__ + "static/web-logo-2-1650ed7ebb4955f485b93d5596bf7c7e.webp";